import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    return (_ctx.isChipShown)
        ? (_openBlock(), _createBlock(_component_Chip, {
            key: 0,
            class: "option-level-name-chip",
            "css-class": _ctx.cssClass,
            text: _ctx.uiLabel
        }, null, 8 /* PROPS */, ["css-class", "text"]))
        : _createCommentVNode("v-if", true);
}
